import TrackerAPI from '../api/tracker.js';
import moment from "moment";

export const trackers = {
  state: {
    assets: null
  },
  actions: {
    loadAssets({ commit }) {
      TrackerAPI.getAssets()
        .then((res) => {
          commit('setAssets', mapRawTrackers(res.data));
        })
        .catch((error) => {
          console.error(error);
        })
    }
  },
  mutations: {
    setAssets(state, assets) {
      state.assets = assets;
    }
  },
  getters: {
    getAssets(state) {
      return state.assets;
    }
  }
};

function mapRawTrackers(rawTrackers) {
  return rawTrackers.map(tracker => {
    return {
      id: tracker.eroad_device_id,
      bookingId: tracker.last_booking_id,
      previousLocation: tracker.previous_location,
      currentLocation: tracker.current_location,
      updatedAt: (tracker.last_location && tracker.last_location.time) ? moment(tracker.last_location.time) : '',
      unlinkedAt: tracker.unlinked_at === '' ? '' : moment(tracker.unlinked_at),
      assetName: tracker.eroad_asset_id,
      recipient: tracker.recipient ? tracker.recipient : '',
      lat: tracker.lat,
      lng: tracker.lng
    }
  });
}
